var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPost(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9h4a.5.5 0 000-1h-4a.5.5 0 000 1zM6.5 11h-2a.5.5 0 000 1h2a.5.5 0 000-1zM5.5 14h-1a.5.5 0 000 1h1a.5.5 0 000-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.707 6.293l-3-3a1 1 0 00-1.414 0L14 4.586 9.707.293A1 1 0 009 0H2a2 2 0 00-2 2v16a2 2 0 002 2h10a2 2 0 002-2v-4.586l5.707-5.707a.999.999 0 000-1.414zM9 2.414L11.586 5H9V2.414zM2 17V3a1 1 0 011-1h5v3a1 1 0 001 1h3v.586l-3.708 3.708a.998.998 0 00-.263.464l-1 4A1.002 1.002 0 008 16c.081 0 .162-.01.243-.03L12 15.031 12.001 17a1 1 0 01-1 1H3a1 1 0 01-1-1zm7.825-5.175l1.351 1.351-1.801.45.45-1.801zm2.468.468l-1.586-1.586 3-3 1.586 1.586-3 3zm4-4l-1.586-1.586L16 5.414 17.586 7l-1.293 1.293z"
  })));
}

export default SvgPost;